<template>
  <v-container class="pa-0" fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <message-notification-dialog type="Processing"/>
      </v-flex>
      <v-flex class="hide-on-xs" md8>
        <slider :type="'Convert'"/>
      </v-flex>
      <v-flex md4 xs12>
        <v-card class="full-height d-flex">
          <v-card-text class="d-flex flex-column">
            <div>
              <div class="layout column align-center my-3">
                <img alt="Nepaliport logo" :src="logoUrl" width="96%">
              </div>
              <div class="mt-2 mb-4 justify-center" style="display: flex;">
                <div class="app-name-panel">Conversion, Certification & Transfer</div>
              </div>
              <v-form class="pt-3 px-2" lazy-validation ref="form" v-model="valid">
                <v-layout column wrap>
                  <form-error-display-handler :errors="errors"/>
                  <v-alert type="info" v-if="info_message" outlined v-html="info_message">
                  </v-alert>
                  <v-flex class="mx-2" md4 xs12>
                    <v-select
                        :items="languages"
                        :label="$vuetify.lang.t('$vuetify.select_language') +' *'"
                        @change="select"
                        outlined
                        v-model="selected"
                    />
                  </v-flex>
                  <v-flex class="mx-2" md4 xs12>
                    <v-autocomplete
                        :items="offices"
                        item-text="name"
                        item-value="slug"
                        :label="$vuetify.lang.t('$vuetify.apply_office') +' *'"
                        outlined
                        v-model="office"
                        :rules="[rules.required]"
                        @change="officeSelected"
                    />
                  </v-flex>
                  <v-flex class="mx-2" md4 xs12 v-if="cannotFindVisa">
                    <v-autocomplete
                        :clearable="true"
                        :items="countries"
                        :label="$vuetify.lang.t('$vuetify.select_country_of_passport')+' *'"
                        :rules="[rules.required]"
                        id="selectCountry"
                        item-text="country_name"
                        item-value="id"
                        outlined
                        v-model="countrySelected"
                    />
                  </v-flex>
                  <v-flex class="mx-2" md4 xs12 v-if="!cannotFindVisa">
                    <v-text-field
                        :clearable="true"
                        :items="languages"
                        :label="$vuetify.lang.t('$vuetify.visa_number')  + ' *'"
                        :rules="[rules.required]"
                        outlined
                        v-model="visa_number"
                    />
                  </v-flex>
                  <v-flex class="mx-2" md4 sm12>
                    <v-text-field
                        :clearable="true"
                        :items="languages"
                        :label="$vuetify.lang.t('$vuetify.passport_number')  + ' *'"
                        :rules="[rules.required]"
                        outlined
                        v-model="passport_number"
                    />
                  </v-flex>
                  <v-flex class="pl-5 mb-4" xs12 v-if="cannotFindVisa">
                    <date-picker-new
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                        :label="$vuetify.lang.t('$vuetify.dob_day')+ ' *'"
                        v-model="dob_date"
                        :min-year="dob.min_year"
                        :max-year="dob.max_year"/>
                  </v-flex>
<!--                  <v-flex sm12 md4 v-if="showVisaInformationNotFound" class="mx-2">-->
<!--                    <v-checkbox-->
<!--                        label="I cannot find my visa information"-->
<!--                        class="mt-0"-->
<!--                        v-model="cannotFindVisa"-->
<!--                    ></v-checkbox>-->
<!--                  </v-flex>-->
                  <v-flex sm12 md4 v-if="visaCannotApplyInOffice" class="mx-2">
                    <v-checkbox
                        label="I want to convert this visa to tourist-visa"
                        class="mt-0"
                        v-model="convertToTourist"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex class="m3-4 mb-2" lg4 md4 sm12 xs12>
                    <v-btn
                        :loading="visaLoading"
                        @click="searchVisa"
                        block
                        color="primary"
                        large
                    >{{ $vuetify.lang.t('$vuetify.proceed') }}
                    </v-btn>
                  </v-flex>
                  <v-flex class="m3-4 mb-2 mt-6" lg4 md4 sm12 xs12
                          v-if="office.toLowerCase() === 'doi' && !cannotFindVisa">
                    <v-btn
                        @click="applyForEntryVisa"
                        block
                        color="secondary"
                        style="background-color: darkblue !important;"
                        large
                    >{{ $vuetify.lang.t('$vuetify.apply_for_entry_visa_processing') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
            <v-spacer/>
            <div>
              <v-layout wrap>
                <v-flex class="row justify-center" xs12>
                  <h5 class="text--darken-1">Developed by &nbsp;</h5>
                  <img alt="Logo Here" height="20px" :src="sarkarLogo" width="24px">
                  <h4 style="color: black">&nbsp;Department of Immigration, Nepal</h4>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import Slider from "./Slider";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {
  AIRPORT,
  BORDER,
  BRANCH_OFFICE,
  MAIN_OFFICE,
  NEPAL_SARKAR_LOGO,
  NEPALIPORT_LOGO_URL
} from "../constant/appConstant";
import MessageNotificationDialog from "../components/MessageNotificationDialog";
import DatePickerNew from "../components/DatePickerNew";

export default {
  components: {
    DatePickerNew,
    MessageNotificationDialog,
    Slider, FormErrorDisplayHandler
  },
  data() {
    return {
      loading: false,
      selected: 'en',
      visaLoading: false,
      notFound: false,
      visa_number: "",
      valid: null,
      errors: [],
      passport_number: "",
      office: '',
      logoUrl: NEPALIPORT_LOGO_URL,
      sarkarLogo: NEPAL_SARKAR_LOGO,
      countrySelected: null,
      cannotFindVisa: false,
      visa_start_date: null,
      visa_end_date: null,
      dob_date: null,
      info_message: null,
      rules: {
        required: value => !!value || "Required."
      },
      showVisaInformationNotFound: false,
      languages: [
        {
          text: "English",
          value: "en"
        },
        {
          text: "Chinese",
          value: "cn"
        }
      ],
      consular: false,
      visaCannotApplyInOffice: false,
      convertToTourist: false
    };
  },
  computed: {
    countries() {
      return this.$store.state.CountryForTouristList.all;
    },
    offices() {
      return this.$store.state.Office.offices.filter(i => {
            return [MAIN_OFFICE, BRANCH_OFFICE, AIRPORT, BORDER].includes(i.type)
          }
      );
    },
    dob() {
      const max_year = new Date().getFullYear();
      const min_year = max_year - 120;
      return {
        min_year,
        max_year
      }
    },
    visa_year() {
      const max_year = new Date().getFullYear() + 1;
      const min_year = max_year - 12;
      return {
        min_year,
        max_year
      }
    },
    visaTypes() {
      return this.$store.state.NewVisaEntry.visaTypes;
    },
  },
  methods: {
    ...mapActions({
      searchForVisa: "VisaSingle/searchForVisa",
      fetchAllNationalities: "CountryForTouristList/fetchAll",
      searchForVisaIfAny: "VisaSingle/searchForVisaIfAny"
    }),
    searchVisa() {
      if (this.$refs.form.validate()) {
        this.$store.commit('VisaSingle/resetState');
        this.$store.commit('VisaSingle/setOffice', this.office);
        this.$store.commit('VisaSingle/setExtendConvertTab',this.$route.query.tab);
        if (!this.cannotFindVisa) {
          this.visaLoading = true;
          let searchData = {
            visa_number: this.visa_number,
            passport_number: this.passport_number,
            office: this.office
          };
          if (this.consular)
            searchData.consular = this.consular;
          if (this.convertToTourist)
            searchData.convert_to_tourist = this.convertToTourist;
          this.searchForVisa(searchData).then(() => {
            this.visaLoading = false;
            this.$router.push({name: "VisaHistory"});
          }).catch((err) => {
            this.visaLoading = false;
            this.errors = [];
            this.errors.push(err.response.data.message);
            this.fetchAllNationalities();
            if(err.response.status === 404)
              this.showVisaInformationNotFound = true;
            if(err.response.status === 400)
              this.visaCannotApplyInOffice = true;
          })
        } else {
          let nationality = this.countries.find(n => n.id === this.countrySelected);
          this.$store.commit("CountryForTouristList/setCurrent", nationality);
          this.$store.commit('VisaSingle/setDOB', this.dob_date);
          this.$store.commit('VisaSingle/setCountry', nationality);
          this.searchForVisaIfAny({
            dob: this.dob_date,
            passport_number: this.passport_number,
            country: this.countrySelected,
          }).then((res) => {
            console.log(res)
            this.errors = [];
            if (res.data.visa_visit) {
              const visa_visit = res.data.visa_visit;
              this.info_message = `You have existing visa of visa number  <b>${visa_visit.visa_number} </b> with duration (${visa_visit.start_date} - ${visa_visit.expiry_date}) . If this information doesn't match with passport please contact to IT section`
            } else {
              this.$router.push({
                name: 'SelfEntry'
              })
            }
          }).catch(() => {
            this.$router.push({
              name: 'SelfEntry'
            })
          })
          // this.$router.push({
          //     name: 'SelfEntry'
          // })


        }

      }
    },
    applyForEntryVisa() {
      this.$router.push({
        name: 'EntryVisaProcessing',
      })
    },
    select(event) {
      this.selected = event;
      this.$vuetify.lang.current = "" + event;
    },
    officeSelected() {

        this.visaCannotApplyInOffice = this.office.toLowerCase() !== 'doi';

    }
  },
  mounted() {
    if(process.env.NODE_ENV == 'development'){
      // this.visa_number = 'T230365058'
      // this.passport_number = 'CD805680'
      this.visa_number = 'T230000015'
      this.passport_number = '211221'
      this.office = 'DoI'
    }
    this.$store.dispatch('fetchOffices', 'processing').then(() => {
      this.fetchAllNationalities();
      if (this.$route.query.passport_number) {
        this.visa_number = this.$route.query.visa_number;
        this.passport_number = this.$route.query.passport_number;
        this.office = this.$route.query.office;
        this.$store.commit('VisaSingle/resetState');
        this.$store.commit('VisaSingle/setOffice', this.office);
        this.$store.commit('VisaSingle/setExtendConvertTab', this.$route.query.tab);
        let searchData = {
          visa_number: this.visa_number,
          passport_number: this.passport_number,
          office: this.office
        };
        this.searchForVisa(searchData).then(() => {
          this.visaLoading = false;
          this.$router.push({name: "VisaHistory"});
        }).catch((err) => {
          this.visaLoading = false;
          this.errors = [];
          this.errors.push(err.response.data.message);
        })
      }
    });
  }
};
</script>
<style lang="css">
.align-center {
  text-align: center;
}
</style>
